.container {
  border: 1px solid var(--color-gray-400);
  border-radius: 32px;
}